<template>
  <div v-loading.body="loading">
    <header-tabs :active="$route.path"></header-tabs>

    <el-row class="filter" :span="24" style="margin-top: 20px">
      <el-col :span="24" style="border-right: 1px solid #ccc">
        <div class="galy-header">基本配置</div>
        <el-form
          ref="form"
          :model="form"
          class="demo-ruleForm"
          :label-width="formLabelWidth"
          style="
            padding-left: 10px;
            display: flex;
            justify-content: space-around;
          "
        >
          <div>
            <el-form-item label="是否开启单件分离:">
              <el-switch v-model="form.only_dabiao" @change="change1">
              </el-switch>
            </el-form-item>
            <el-form-item label="单件分离是否开启今日配齐:">
              <el-switch v-model="form.today_full_allot" @change="change2">
              </el-switch>
            </el-form-item>
            <el-form-item label="单件分离是否人工汇集:">
              <el-switch
                v-model="form.only_surpass"
                :inactive-value="0"
                :active-value="1"
                @change="changeOneSurpass"
              >
              </el-switch>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="是否开启质检分离:">
              <el-switch v-model="form.quality_dabiao" @change="change3">
              </el-switch>
            </el-form-item>
            <el-form-item label="质检分离是否人工汇集:">
              <el-switch
                v-model="form.quality_surpass"
                :inactive-value="0"
                :active-value="1"
                @change="changeQualitySurpass"
              >
              </el-switch>
            </el-form-item>
            <el-form-item label="商品对应订单有备注是否可以生成新的越库波次">
              <el-switch
                v-model="remarkNewSurpass"
                inactive-value="0"
                active-value="1"
                @change="changeRemarkNewSurpass"
              >
              </el-switch>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="是否开启改标分离:">
              <el-switch v-model="form.label_dabiao" @change="change4">
              </el-switch>
            </el-form-item>
            <el-form-item label="改标分离是否人工汇集:">
              <el-switch
                v-model="form.label_surpass"
                :inactive-value="0"
                :active-value="1"
                @change="changeLabelSurpass"
              >
              </el-switch>
            </el-form-item>
            <el-form-item label="囤货分离是否人工汇集:">
              <el-switch
                v-model="form.stock_surpass"
                :inactive-value="0"
                :active-value="1"
                @change="changeStockSurpass"
              >
              </el-switch>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="是否开启【带配件/套装】分离开关">
              <el-switch
                v-model="form.suit_or_parts_dabiao"
                @change="change5"
              ></el-switch>
            </el-form-item>
            <el-form-item label="是否开启囤货分离:">
              <el-switch
                v-model="form.stock_dabiao"
                :inactive-value="0"
                :active-value="1"
                @change="changeStockSeparation"
              >
              </el-switch>
            </el-form-item>
          </div>
        </el-form>
      </el-col>
    </el-row>
    <el-row style="display: flex; border: 1px solid #ccc">
      <el-col :span="9" style="border-right: 1px solid #ccc">
        <div class="galy-header">越库分离配置</div>
        <el-form
          :model="surpassForm"
          label-width="290px"
          style="padding-left: 10px"
        >
          <el-form-item label="是否开启越库分离: " required>
            <el-switch
              v-model="surpassForm.surpass_dabiao_open"
              :inactive-value="0"
              :active-value="1"
            ></el-switch>
          </el-form-item>
          <el-form-item label="越库分离单个波次商家数量: " required>
            <el-input-number
              v-model="surpassForm.wave_max_supply_num"
              size="small"
              :min="1"
              :max="9999"
              :disabled="surpassForm.surpass_dabiao_open == 0"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="越库分离单个中分任务波次数上限: " required>
            <el-input-number
              v-model="surpassForm.halve_include_wave_num"
              size="small"
              :min="1"
              :max="9999"
              :disabled="surpassForm.surpass_dabiao_open == 0"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="越库分离商品一级分类范围: " required>
            <el-select
              v-model="surpassForm.cat_ids"
              multiple
              size="small"
              :disabled="surpassForm.surpass_dabiao_open == 0"
            >
              <el-option value="0" label="全部"></el-option>
              <el-option
                v-for="item in cats"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="越库分离单波次件数上限: " required>
            <el-input-number
              v-model="surpassForm.wave_max_piece_num"
              size="small"
              :disabled="surpassForm.surpass_dabiao_open == 0"
              :min="1"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="VIP中分分组: " required>
            <el-select
              v-model="surpassForm.vip_hg"
              filterable
              multiple
              size="small"
            >
              <el-option
                v-for="item in halve_group"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="VIP中分分组单个中分任务波次数上限: " required>
            <el-input-number
              v-model="surpassForm.vip_hg_max_wave_num"
              size="small"
              :min="1"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="库存类型中分位单个中分任务波次数上限: " required>
            <el-input-number
              v-model="surpassForm.stock_hg_max_wave_num"
              size="small"
              :min="0"
            ></el-input-number>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="saveSurpass">保存</el-button>
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :span="8" style="border-right: 1px solid #ccc">
        <div class="galy-header">越库分离追加配置</div>
        <div style="margin-top: 30px; padding-left: 20px">
          越库用户配置：
          <el-upload
            style="display: inline-block; margin-left: 20px"
            :action="action1"
            name="file"
            :data="{ save_type: 1 }"
            :on-success="importSuccess"
            :on-error="importError"
            :show-file-list="false"
            with-credentials
          >
            <el-button size="small" type="primary">导入</el-button>
          </el-upload>
          <el-button type="success" size="small" @click="exportSetting(1)">
            下载现有配置
          </el-button>
          <div style="font-size: 13px; color: red">
            每次导入，新文件会覆盖旧文件，请下载现有配置后增加新用户id
          </div>
        </div>
        <div style="margin-top: 30px; padding-left: 20px">
          订单待配含以下货号时越库：
          <el-upload
            style="display: inline-block; margin-left: 20px"
            :action="action1"
            name="file"
            :data="{ save_type: 2 }"
            :on-success="importSuccess"
            :on-error="importError"
            :show-file-list="false"
            with-credentials
          >
            <el-button size="small" type="primary">导入</el-button>
          </el-upload>
          <el-button type="success" size="small" @click="exportSetting(2)">
            下载现有配置
          </el-button>
          <div style="font-size: 13px; color: red">
            每次导入，新文件会覆盖旧文件，请下载现有配置后增加新货号
          </div>
        </div>
        <div style="margin-top: 30px; padding-left: 20px">
          越库商家配置：
          <el-upload
            style="display: inline-block; margin-left: 20px"
            :action="action1"
            name="file"
            :data="{ save_type: 4 }"
            :on-success="importSuccess"
            :on-error="importError"
            :show-file-list="false"
            with-credentials
          >
            <el-button size="small" type="primary">导入</el-button>
          </el-upload>
          <el-button type="success" size="small" @click="exportSetting(4)">
            下载现有配置
          </el-button>
          <div style="font-size: 13px; color: red">
            每次导入，新文件会覆盖旧文件，请下载现有配置后增加新商家id
          </div>
        </div>
        <div style="margin-top: 30px; padding-left: 20px">
          订单待发商品大于多少件时越库：
          <el-input
            v-model="surpassOrderNeedNum"
            placeholder="输入后回车保存"
            style="width: 140px"
            size="small"
            @keypress.native.enter="changeSurpassOrderNeedNum"
          ></el-input>
        </div>
      </el-col>

      <el-col :span="7">
        <div class="galy-header">越库限制条件</div>
        <div style="margin-top: 30px; padding-left: 20px">
          是否开启：<el-switch
            v-model="surpass_ban.is_open"
            inactive-value="0"
            active-value="1"
            @change="saveSurpassBanSetting(1)"
          ></el-switch>
        </div>
        <div style="margin-top: 30px; padding-left: 20px">
          限制用户配置：
          <el-upload
            style="display: inline-block; margin-left: 20px"
            :action="action2"
            name="file"
            :data="{ save_type: 2 }"
            :on-success="importSuccess"
            :on-error="importError"
            :show-file-list="false"
            with-credentials
          >
            <el-button size="small" type="primary">导入</el-button>
          </el-upload>
          <el-button
            type="success"
            size="small"
            @click="exportSurpassBanSetting(1)"
            >下载现有配置</el-button
          >
          <div style="font-size: 13px; color: red">
            每次导入，新文件会覆盖旧文件，请下载现有配置后增加新用户id
          </div>
        </div>

        <div style="margin-top: 30px; padding-left: 20px">
          限制收件地市：
          <el-button type="primary" size="small" @click="selectRegionCall">
            添加限制地市
          </el-button>

          <div
            v-if="surpass_ban.area_text.length > 0"
            style="display: inline-block"
          >
            限制单件分离：<el-switch
              v-model="surpass_ban.area_restrict_single_detach"
              @change="saveSurpassBanSetting(6)"
            ></el-switch>
          </div>
          <div style="display: inline-block">
            限制质检分离：<el-switch
              v-model="surpass_ban.area_restrict_quality_detach"
              :active-value="1"
              :inactive-value="0"
              @change="saveSurpassBanSetting(8)"
            ></el-switch>
          </div>
          <div style="display: inline-block">
            限制停发地区自动生成质检汇总任务：
            <el-switch
              v-model="surpass_ban.area_quality_limit"
              :active-value="1"
              :inactive-value="0"
              @change="saveSurpassBanSetting(9)"
            >
            </el-switch>
          </div>
          <div
            style="border: 1px solid #eee; max-height: 350px; overflow: auto"
            class="tag-group"
          >
            <!-- {{surpass_ban.area_text}} -->
            <el-tag
              v-for="item in surpass_ban.area_text"
              :key="item.value"
              effect="plain"
              closable
              style="margin: 3px 3px 0 0"
              @close="removeBanArea(item.value)"
            >
              {{ item.label }}
            </el-tag>
          </div>
          <!-- <el-input v-model="surpass_ban.area_text" readonly  style="width:220px" size="small"></el-input> -->
        </div>

        <div style="margin-top: 30px; padding-left: 20px; display: flex">
          <div>库存仓区占比配置：</div>
          <div>
            波次待发件数大于<el-input
              v-model="surpass_ban.wave_wait_out_num"
              style="width: 50px"
              size="mini"
              @keydown.enter.native="tryToSave"
            ></el-input
            ><br /><br />
            且发货仓区件数大于<el-input
              v-model="surpass_ban.out_storage_num"
              style="width: 50px"
              size="mini"
              @keydown.enter.native="tryToSave"
            ></el-input
            >%
          </div>
        </div>
        <div style="margin-top: 30px; padding-left: 20px">
          同纬度订单有已锁定未出库的越库波次不再生成越库波次：<el-switch
            v-model="surpass_ban.dimension_limit"
            inactive-value="0"
            active-value="1"
            @change="saveSurpassBanSetting(7)"
          ></el-switch>
        </div>
      </el-col>
    </el-row>

    <el-row style="border: 1px solid #ccc">
      <el-col :span="24" style="height: 100%">
        <div class="galy-header">今日不发配置</div>
        <el-form
          :model="todayNoShipping"
          label-width="240px"
          style="padding-left: 30px"
        >
          <el-form-item label="" required>
            <span
              >1.待配非单件的波次已配数量为1件时,且当前时间未超过波次生成时间:
            </span>
            <el-input
              v-model="todayNoShipping.time"
              size="small"
              style="width: 120px"
              :min="1"
            ></el-input>
            <span>小时,且所配商品金额超过</span>
            <el-input
              v-model="todayNoShipping.money"
              size="small"
              style="width: 120px"
              :min="1"
            ></el-input>
            <span>元,波次为今日未配齐</span>
          </el-form-item>
          <el-form-item label="" required>
            <span>2.今日配货率小于 </span>
            <el-input
              v-model="todayNoShipping.percent"
              size="small"
              style="width: 120px"
              :min="0"
            ></el-input>
            <span
              >%，相应波次为“未配齐”。（今日配货率=今日配货商品数量/未发货订单订货商品数量）</span
            >
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="saveNoShipping">保存</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <!-- 地区选择器 -->
    <select-region ref="selectRegionRef" @submit="regionSubmit"></select-region>
  </div>
</template>

<script>
import HeaderTabs from "./components/HeaderTabs.vue";
import selectRegion from "@/components/SelectRegionDialog.vue";
import * as wavePicking from "@/controller/wavePicking.js";
import * as warehouseConfig2278Api from "@/controller/warehouseConfig2278.js";
import apiBaseURL from "@/utils/baseUrl.js";

const REMARK_NEW_SURPASS = {
  CLOSED: "0", // 备注生成新波次配置（0: 关闭）
  OPEN: "1", // 备注生成新波次配置（1:开启）
};

const baseConfigTypes = {
  SINGLE_PIECE: 1, // 单件分离
  SINGLE_PIECE_MAKE_UP_TODAY: 2, // 单件分离今日配齐
  QUALITY_PIECE: 3, // 质检分离
  REMARKING_PIECE: 4, // 改标分离
  SINGLE_PIECE_MANUAL_COUNT: 5, // 单件分离需要人工汇集
  QUALITY_PIECE_MANUAL_COUNT: 6, // 质检分离需要人工汇集
  REMARKING_PIECE_MANUAL_COUNT: 7, // 改标分离需要人工汇集
  SUIT_PARTS_PIECE: 8, // 套装、配件分离
  STOCK_PIECE: 9, // 囤货分离
  STOCK_PIECE_MANUAL_COUNT: 10, // 囤货分离需要人工汇集
};

export default {
  components: { HeaderTabs, selectRegion },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
      vm.getSurpass();
      vm.getTodayNotShipping();
    });
  },
  data() {
    return {
      REMARK_NEW_SURPASS,
      form: {
        only_dabiao: false,
        today_full_allot: false,
        quality_dabiao: false,
        label_dabiao: false,
        suit_or_parts_dabiao: false,
      },
      loading: false,
      tableLoading: false,
      url: "/erp/WavePicking/onlyDabiaoSetting",
      filterFold: false,
      supplyData: null,
      origin: 1,
      origin_txt: 1,
      formLabelWidth: "270px",
      // 越库分离配置
      surpassForm: {
        surpass_dabiao_open: 0,
        wave_max_supply_num: 0,
        wave_max_piece_num: 0,
        cat_ids: ["0"],
        halve_include_wave_num: 0,
        only_surpass: 0,
        quality_surpass: 0,
        label_surpass: 0,
        vip_hg: [],
        vip_hg_max_wave_num: 24,
        stock_hg_max_wave_num: 0,
      },
      todayNoShipping: {},
      cats: [],
      surpassOrderNeedNum: "",
      halve_group: [],

      // 越库限制条件
      surpass_ban: {
        is_open: "0", // 开关
        area_text: [], // 地区显示
        area_id: [],
        wave_wait_out_num: "", // 波次待发件数
        out_storage_num: "", // 发货仓区件数
        remove_area_id: "", // 用于删除地区限制的传参
        area_restrict_single_detach: false, // 限制单件分离
        dimension_limit: 0, // 同纬度订单有已锁定未出库的越库波次不再生成越库波次
        area_restrict_quality_detach: 0, // 限制质检分离
        area_quality_limit: 0, // 限制停发地区自动生成质检汇总任务
      },
      remarkNewSurpass: REMARK_NEW_SURPASS.CLOSED, // 备注生成新波次配置（0: 关闭，1:开启）
      action1: `${apiBaseURL}/erp/SurpassSummary/saveSupassExtSetting`,
      action2: `${apiBaseURL}/erp/SurpassSummary/saveSurpassBanSetting`,
    };
  },
  computed: {
    filteredForm() {
      const { form } = this;
      Object.keys(form).forEach((key) => {
        if (form[key] === undefined || form[key] === "" || form[key] === null) {
          delete form[key];
        }
      });
      return form;
    },
  },
  mounted() {
    this.getRemarkNewSurpassConfig();
  },
  methods: {
    removeShipping(item) {
      const index = this.form.shipping_companies.indexOf(item);
      if (index !== -1) {
        this.form.shipping_companies.splice(index, 1);
      }
    },
    addShipping() {
      this.form.shipping_companies.push({
        key: Date.now(),
        min: 0,
        max: 0,
        shipping_company: "",
      });
    },
    saveNoShipping() {
      this.$http
        .post("/erp/WavePicking/todayNotShippingSetting", this.todayNoShipping)
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
            return;
          }
          this.$message.success("保存成功");
        });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.get(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form = res.data.data;
          this.origin = res.data.data.origin;
          this.origin_txt = res.data.data.origin_txt;
        }
      });
    },
    change1($e) {
      this.onSubmit($e, baseConfigTypes.SINGLE_PIECE);
    },
    change2($e) {
      this.onSubmit($e, baseConfigTypes.SINGLE_PIECE_MAKE_UP_TODAY);
    },
    change3($e) {
      this.onSubmit($e, baseConfigTypes.QUALITY_PIECE);
    },
    change4($e) {
      this.onSubmit($e, baseConfigTypes.REMARKING_PIECE);
    },
    changeOneSurpass($e) {
      this.onSubmit($e, baseConfigTypes.SINGLE_PIECE_MANUAL_COUNT);
    },
    changeQualitySurpass($e) {
      this.onSubmit($e, baseConfigTypes.QUALITY_PIECE_MANUAL_COUNT);
    },
    changeLabelSurpass($e) {
      this.onSubmit($e, baseConfigTypes.REMARKING_PIECE_MANUAL_COUNT);
    },
    change5($e) {
      this.onSubmit($e, baseConfigTypes.SUIT_PARTS_PIECE);
    },
    changeStockSeparation($e) {
      this.onSubmit($e, baseConfigTypes.STOCK_PIECE);
    },
    changeStockSurpass($e) {
      this.onSubmit($e, baseConfigTypes.STOCK_PIECE_MANUAL_COUNT);
    },
    onSubmit($e, type) {
      this.form.origin = this.origin;
      let msg = "";
      if (type === baseConfigTypes.SINGLE_PIECE) {
        if ($e === true) {
          msg = "是否确认开启单件分离？";
        } else {
          msg = "是否确认关闭单件分离？";
        }
      } else if (type === baseConfigTypes.SINGLE_PIECE_MAKE_UP_TODAY) {
        if ($e === true) {
          msg = "是否确认开启单件分离今日配齐？";
        } else {
          msg = "是否确认关闭单件分离今日配齐？";
        }
      } else if (type === baseConfigTypes.QUALITY_PIECE) {
        if ($e === true) {
          msg = "是否开启质检分离？";
        } else {
          msg = "是否关闭质检分离？";
        }
      } else if (type === baseConfigTypes.REMARKING_PIECE) {
        if ($e === true) {
          msg = "是否开启改标分离？";
        } else {
          msg = "是否关闭改标分离？";
        }
      } else if (type === baseConfigTypes.SINGLE_PIECE_MANUAL_COUNT) {
        if ($e) {
          msg = "是否开启单件分离需要人工汇集？";
        } else {
          msg = "是否关闭单件分离需要人工汇集？";
        }
      } else if (type === baseConfigTypes.QUALITY_PIECE_MANUAL_COUNT) {
        if ($e) {
          msg = "是否开启质检分离需要人工汇集？";
        } else {
          msg = "是否关闭质检分离需要人工汇集？";
        }
      } else if (type === baseConfigTypes.REMARKING_PIECE_MANUAL_COUNT) {
        if ($e) {
          msg = "是否开启改标分离需要人工汇集？";
        } else {
          msg = "是否关闭改标分离需要人工汇集？";
        }
      } else if (type === baseConfigTypes.SUIT_PARTS_PIECE) {
        if ($e === true) {
          msg = "是否开启套装、配件分离?";
        } else {
          msg = "是否关闭套装、配件分离?";
        }
      } else if (type === baseConfigTypes.STOCK_PIECE) {
        if ($e) {
          msg = "是否确认开启囤货分离？";
        } else {
          msg = "是否确认关闭囤货分离？";
        }
      } else if (type === baseConfigTypes.STOCK_PIECE_MANUAL_COUNT) {
        if ($e) {
          msg = "是否开启囤货分离需要人工汇集？";
        } else {
          msg = "是否关闭囤货分离需要人工汇集？";
        }
      }

      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log("this.filteredForm", this.filteredForm);
          const { stock_dabiao: stockDabiao, stock_surpass: stockSurpass } =
            this.filteredForm;
          const isOpenStockPiece =
            type === baseConfigTypes.STOCK_PIECE && stockDabiao === 1;
          // 开启囤货分离 默认开启囤货人工汇集
          let newStockSurpass = stockSurpass;
          if (isOpenStockPiece) {
            newStockSurpass = 1;
          }
          const params = {
            ...this.filteredForm,
            stock_surpass: newStockSurpass,
          };

          this.$http.post(this.url, params).then((res) => {
            setTimeout(() => {
              this.loading = false;
            }, 200);
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.$message.success("修改成功");
              // 手动修改囤货分离汇集
              if (isOpenStockPiece) {
                this.filteredForm.stock_surpass = 1;
              }
            }
          });
        })
        .catch(() => {
          if (type === baseConfigTypes.SINGLE_PIECE) {
            this.form.only_dabiao = !$e;
          } else if (type === baseConfigTypes.SINGLE_PIECE_MAKE_UP_TODAY) {
            this.form.today_full_allot = !$e;
          } else if (type === baseConfigTypes.QUALITY_PIECE) {
            this.form.quality_dabiao = !$e;
          } else if (type === baseConfigTypes.REMARKING_PIECE) {
            this.form.label_dabiao = !$e;
          } else if (type === baseConfigTypes.SINGLE_PIECE_MANUAL_COUNT) {
            if ($e) {
              this.form.only_surpass = 0;
            } else {
              this.form.only_surpass = 1;
            }
          } else if (type === baseConfigTypes.QUALITY_PIECE_MANUAL_COUNT) {
            if ($e) {
              this.form.quality_surpass = 0;
            } else {
              this.form.quality_surpass = 1;
            }
          } else if (type === baseConfigTypes.REMARKING_PIECE_MANUAL_COUNT) {
            if ($e) {
              this.form.label_surpass = 0;
            } else {
              this.form.label_surpass = 1;
            }
          } else if (type === baseConfigTypes.SUIT_PARTS_PIECE) {
            this.form.suit_or_parts_dabiao = !$e;
          } else if (type === baseConfigTypes.STOCK_PIECE) {
            if ($e) {
              this.form.stock_dabiao = 0;
            } else {
              this.form.stock_dabiao = 1;
            }
          } else if (type === baseConfigTypes.STOCK_PIECE_MANUAL_COUNT) {
            if ($e) {
              this.form.stock_surpass = 0;
            } else {
              this.form.stock_surpass = 1;
            }
          }
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 设置 - 商品对应订单有备注是否可以生成新的越库波次
    changeRemarkNewSurpass() {
      this.$confirm(
        "确定修改商品对应订单有备注是否可以生成新的越库波次吗？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          const postData = {
            remark_new_surpass: this.remarkNewSurpass,
          };
          wavePicking.setRemarkNewSurpassConfig(postData).then((res) => {
            this.$message.success("修改成功");
          });
        })
        .catch(() => {
          this.remarkNewSurpass =
            this.remarkNewSurpass === REMARK_NEW_SURPASS.CLOSED
              ? REMARK_NEW_SURPASS.OPEN
              : REMARK_NEW_SURPASS.CLOSED;
        });
    },
    // 获取 - 商品对应订单有备注是否可以生成新的越库波次
    getRemarkNewSurpassConfig() {
      wavePicking.getRemarkNewSurpassConfig().then((res) => {
        this.remarkNewSurpass = res.remark_new_surpass;
      });
    },

    // 获取越库分离配置
    getSurpass() {
      warehouseConfig2278Api.getSurpassSetting().then((res) => {
        const { setting = {}, cats = [], halve_group: halveGroup = [] } = res;
        this.surpassOrderNeedNum = setting.surpass_order_need_num;
        this.surpassForm = setting;
        delete this.surpassForm.surpass_order_need_num;
        this.cats = cats;
        this.halve_group = halveGroup;

        // 越库限制条件
        const { setting_ban: settingBan } = res;
        this.surpass_ban.is_open = settingBan.is_open;
        this.surpass_ban.area_id = settingBan.area_id;
        this.surpass_ban.area_text = settingBan.area_text;
        this.surpass_ban.wave_wait_out_num = settingBan.wave_wait_out_num;
        this.surpass_ban.out_storage_num = settingBan.out_storage_num;
        this.surpass_ban.area_restrict_single_detach =
          settingBan.area_restrict_single_detach;
        this.surpass_ban.area_restrict_quality_detach =
          settingBan.area_restrict_quality_detach;
        this.surpass_ban.area_quality_limit = settingBan.area_quality_limit;
        // comment
        this.surpass_ban.dimension_limit = settingBan.dimension_limit;
      });
    },
    // 获取今日不发配置
    getTodayNotShipping() {
      this.$http.get("/erp/WavePicking/todayNotShippingSetting").then((res) => {
        this.todayNoShipping = res.data.data;
      });
    },
    // 保存越库配置
    saveSurpass() {
      if (
        this.surpassForm.cat_ids.includes("0") &&
        this.surpassForm.cat_ids.length > 1
      ) {
        this.$message.error('勾选了"全部"分类不能和其他一级分类混合');
        return;
      }
      this.$http
        .post("/erp/SurpassSummary/saveSurpassSetting", this.surpassForm)
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
            return;
          }
          this.$message.success(res.data.msg);
        });
    },

    // 保存波次待发数量大于x件越库的配置
    changeSurpassOrderNeedNum() {
      let msg = "空值时表示取消此配置, 是否确定?";
      if (this.surpassOrderNeedNum.length > 0) {
        msg = `波次待发商品大于${this.surpassOrderNeedNum}时越库, 是否保存?`;
      }
      this.$confirm(msg, "提示", {
        closeOnClickModal: false,
      })
        .then(() => {
          this.$http
            .post("/erp/SurpassSummary/saveSupassExtSetting", {
              save_type: 3,
              surpass_order_need_num: this.surpassOrderNeedNum,
            })
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message.error(res.data.msg);
                return;
              }
              this.$message.success(res.data.msg);
            });
        })
        .catch(() => {
          this.$message.info("未保存");
        });
    },

    importSuccess(data) {
      this.$message.success(data.msg);
    },

    importError() {
      this.$message.error("导入失败了");
    },

    // 导出配置
    exportSetting(exportType) {
      this.$http
        .post("/erp/SurpassSummary/exportSurpassExtSetting", {
          export_type: exportType,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
            return;
          }
          window.open(apiBaseURL + res.data.data.file);
        });
    },

    // 保存越库限制配置
    // @param save_type 保存类型 {1:开关, 2:导入用户, 3:保存收件地市, 4:保存库存仓区占比配置}
    saveSurpassBanSetting(saveType) {
      const param = { save_type: saveType };
      switch (saveType) {
        case 1: // 开关
          param.is_open = this.surpass_ban.is_open;
          break;

        case 3: // 添加地区限制
          param.area = this.surpass_ban.area_id;
          break;

        case 4: // 库存仓区占比限制
          param.wave_wait_out_num = this.surpass_ban.wave_wait_out_num;
          param.out_storage_num = this.surpass_ban.out_storage_num;
          break;

        case 5: // 移除地区限制
          param.area_remove = this.surpass_ban.remove_area_id;
          break;

        case 6: // 限制单件分离
          param.area_restrict_single_detach =
            this.surpass_ban.area_restrict_single_detach;
          break;
        case 7: // 开关
          param.dimension_limit = this.surpass_ban.dimension_limit;
          break;
        case 8: // 质检分离
          param.area_restrict_quality_detach =
            this.surpass_ban.area_restrict_quality_detach;
          break;
        case 9: // 限制停发地区自动生成质检汇总任务
          param.area_quality_limit = this.surpass_ban.area_quality_limit;
          break;
        default:
          break;
      }
      return new Promise((resolve, reject) => {
        this.$http
          .post("/erp/SurpassSummary/saveSurpassBanSetting", param)
          .then((res) => {
            if (res.data.code !== 200) {
              this.$message.e(res.data.msg);
              reject();
              return;
            }
            resolve(res.data.data);
            this.$message.success(res.data.msg);
          });
      });
    },

    // 导出越库限制配置
    exportSurpassBanSetting() {
      this.$http
        .post("/erp/SurpassSummary/exportSurpassBanSetting")
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
            return;
          }
          window.open(apiBaseURL + res.data.data.file);
        });
    },

    // 选择地区
    selectRegionCall() {
      this.$refs.selectRegionRef.call();
    },

    // 确定选择地区
    regionSubmit(data) {
      // console.log(data);
      // if (data.value.length < 2) {
      //     return this.$message.e('请至少选择到城市');
      // }

      // this.surpass_ban.area_text = data.label;
      // this.surpass_ban.area_id = data.value;
      this.surpass_ban.area_id = [];
      data.forEach((row) => {
        this.surpass_ban.area_id.push(row.value);
      });
      // 先保存
      this.saveSurpassBanSetting(3)
        .then((res) => {
          this.surpass_ban.area_text = res.area;
        })
        .catch(() => {});
    },

    // 移除地区
    removeBanArea(areaId) {
      this.surpass_ban.remove_area_id = areaId;
      this.saveSurpassBanSetting(5)
        .then((res) => {
          this.surpass_ban.area_text = res.area;
        })
        .catch(() => {});
    },

    // 输入比例时enter尝试保存
    tryToSave() {
      // if (this.surpass_ban.wave_wait_out_num || this.surpass_ban.out_storage_num){
      //     return;
      // }
      // 直接保存, 不用判断了
      this.saveSurpassBanSetting(4);
    },
  },
};
</script>

<style scoped>
.galy-header {
  padding: 5px 10px;
  background-color: #eee;
}

.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/wavepicking/OnlyDabiaoSetting.vue